import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One-time exchange of the Emergent session_id (from URL fragment) for a session cookie.
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const hash = location.hash || window.location.hash;
        const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
        (async () => {
            if (!sid) {
                navigate("/admin", { replace: true });
                return;
            }
            try {
                const { data } = await axios.post(
                    `${API}/auth/session`,
                    { session_id: sid },
                    { withCredentials: true }
                );
                window.history.replaceState({}, "", "/admin");
                navigate("/admin", { replace: true, state: { user: data } });
            } catch (e) {
                navigate("/admin", { replace: true, state: { error: "auth_failed" } });
            }
        })();
    }, [location, navigate]);

    return (
        <div className="min-h-screen bg-aq-navy flex items-center justify-center text-aq-cream">
            <div className="text-center">
                <div className="w-10 h-10 border-2 border-aq-gold border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                <p className="font-serif text-xl">Signing you in…</p>
            </div>
        </div>
    );
}
